interface FailureError {
  ErrorMessage: string;
  InternalErrorMessage: string;
}

interface ErrorCollection {
  DataValidationErros: FailureError[];
  SystemFailureErros: FailureError[];
}

interface SummaryError {
  Success: boolean;
  ErrorCollection: ErrorCollection;
}

interface Error {
  Summary: SummaryError;
}

export default function ConvertArrayBufferToData(
  arrayBuffer: ArrayBuffer,
): Error {
  const enc = new TextDecoder('utf-8');
  const textResponse = enc.decode(arrayBuffer);
  try {
    const parsedResponse = JSON.parse(textResponse);
    return parsedResponse;
  } catch (err) {
    return {
      Summary: {
        Success: false,
        ErrorCollection: { DataValidationErros: [], SystemFailureErros: [] },
      },
    };
  }
}
